import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { superAdminApi } from '../api/superAdminApi';

export function useSuperAdminOrders(params) {
  return useQuery({
    queryKey: ['superadmin', 'orders', params],
    queryFn: () => superAdminApi.getOrders(params),
    keepPreviousData: true,
  });
}

export function useSuperAdminOrder(orderId) {
  return useQuery({
    queryKey: ['superadmin', 'order', orderId],
    queryFn: () => superAdminApi.getOrder(orderId),
    enabled: Boolean(orderId),
  });
}

export function useMarkOrderDelivered() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (orderId) => superAdminApi.markOrderDelivered(orderId),
    onSuccess: (updatedOrder, orderId) => {
      qc.setQueriesData({ queryKey: ['superadmin', 'orders'] }, (current) => {
        if (!current?.items) return current;

        return {
          ...current,
          items: current.items.map((order) => (
            order.id === updatedOrder.id
              ? { ...order, ...updatedOrder }
              : order
          )),
        };
      });
      qc.invalidateQueries({ queryKey: ['superadmin', 'orders'] });
      qc.invalidateQueries({ queryKey: ['superadmin', 'order', orderId] });
    },
  });
}